import { render, staticRenderFns } from "./ClinicPayments.vue?vue&type=template&id=343ebb8b"
import script from "./ClinicPayments.vue?vue&type=script&lang=js"
export * from "./ClinicPayments.vue?vue&type=script&lang=js"
import style0 from "./ClinicPayments.vue?vue&type=style&index=0&id=343ebb8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports